import { motion, useInView } from 'framer-motion';
import { useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const ZOLA_URL = 'https://www.zola.com/registry/gift-tracker/your-gifts';

export const FAQ = () => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    { q: t('faqDressCode'), a: t('faqDressCodeAnswer') },
    { q: t('faqTransport'), a: t('faqTransportAnswer') },
    { q: t('faqParking'), a: t('faqParkingAnswer') },
    { q: t('faqKids'), a: t('faqKidsAnswer') },
    { q: t('faqGifts'), a: t('faqGiftsAnswer'), linkWord: 'Zola', linkUrl: ZOLA_URL },
  ];

  return (
    <section ref={ref} className="py-20 bg-white" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }} className="text-center mb-12">
          <h2 className="font-serif text-4xl sm:text-5xl text-[#1A2B3D] mb-4">{t('faqTitle')}</h2>
          <div className="wave-divider" />
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }} className="space-y-3">
          {faqs.map((faq, index) => (
            <div key={faq.q} className="border border-[#CBD5E1] rounded-sm overflow-hidden"
              data-testid={`faq-item-${index}`}>
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-[#EFF4F9]/50 transition-colors">
                <span className="font-serif text-lg text-[#1A2B3D]">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-[#6B8299] transition-transform duration-200 flex-shrink-0 ml-4 ${
                  openIndex === index ? 'rotate-180' : ''
                }`} />
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-[#6B8299] text-sm leading-relaxed">
                    {faq.linkWord ? faq.a.split(faq.linkWord).map((part, i, arr) => (
                      <span key={i}>
                        {part}
                        {i < arr.length - 1 && (
                          <a href={faq.linkUrl} target="_blank" rel="noopener noreferrer"
                            className="text-[#1E3A5F] underline underline-offset-2 hover:text-[#C9A96E] transition-colors"
                            data-testid="faq-zola-link">{faq.linkWord}</a>
                        )}
                      </span>
                    )) : faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
